import { selectQueryString } from '../results';
import { selectEarlyAccessEnabled } from './selectEarlyAccessEnabled';
import { IAppState } from 'shared/common/state';

export const selectEarlyAccessUrl = (state: IAppState) => {
  const queryString = selectQueryString(state);
  const isEarlyAccessEnabled = selectEarlyAccessEnabled(state);

  /**
   * @description
   * Если фильтр включен, то не показываем ссылку
   */
  if (isEarlyAccessEnabled || queryString.includes('is_early_access_enabled=1')) {
    return null;
  }

  return `/cat.php?${queryString}&is_early_access_enabled=1`;
};
